import { render, staticRenderFns } from "./stepAbrirRemessa.vue?vue&type=template&id=72def8e4"
import script from "./stepAbrirRemessa.vue?vue&type=script&lang=ts"
export * from "./stepAbrirRemessa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports